import { SET_INFO_DATA } from "./info-data-actions";
import { InfoDataState } from "./info-data-types";

export const INFO_DATA_INITIAL_STATE: InfoDataState = {
  // replaced with dispatch(fetchCropTypesAction()).unwrap(),
  // cropTypes: [],

  departments: [],
  employees: [],
  farms: [],
  positions: [],
  seasons: undefined, // undefined => NOT_YET_LOADED
  workPlace: [],
  techOperationGroups: [],
  techOperationSubGroups: [],
  techOperationSubGroupIdsWithCropTypeRelations: [],
  techAssets: [],
  techAssetCategory: [],
  phenoPhases: [],
  techOperationsScalars: [],

  //https://tracker.yandex.ru/DEVELOPMENT-3948
  techOperationMeasuresSets: [],
  measures: [],
  techOperationParams: [],

  initialDictionariesLoaded: false,
};

// eslint-disable-next-line
export const infoDataReducer = (state = INFO_DATA_INITIAL_STATE, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case SET_INFO_DATA:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
